import { NgModule, NO_ERRORS_SCHEMA } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { UserflowInitializerComponent } from './userflow.initializer.component';

import { UserflowService } from './userflow.service';

@NgModule({
  declarations: [
    UserflowInitializerComponent
  ],
  entryComponents: [
    UserflowInitializerComponent
  ],
  exports: [
    UserflowInitializerComponent
  ],
  imports: [
    SharedModule
  ],
  providers: [
    UserflowService
  ],
  schemas: [NO_ERRORS_SCHEMA] })
export class UserflowModule {}
